import React from "react";
import SystemGraphs from "./SystemGraphs";

const RechargeStations = () => {
  const defaultParameter = 67;

  const pageTitle = "Recharge Stations";

  const endpoints = [
    { label: "15 Minutes", value: "display002-data15-min" },
    { label: "Daily", value: "display002-data-daily" },
  ];

  const parametersEndpoint = "display002-lookup-parameter";

  const mapEndpoint = "display002-map-points";

  return (
    <>
      <SystemGraphs
        defaultParameter={defaultParameter}
        pageTitle={pageTitle}
        endpoints={endpoints}
        parametersEndpoint={parametersEndpoint}
        mapEndpoint={mapEndpoint}
      />
    </>
  );
};

export default RechargeStations;
